import React, { Component, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import moment from "moment";
import { Row, Col, Card, Badge, Table as Tbl } from "react-bootstrap";
import {
    TextField,
    Button,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    Checkbox
} from "@material-ui/core";

import Autocomplete from "@material-ui/lab/Autocomplete";
// import Box from '@mui/material/Box';
import Box from "@material-ui/core/Box"

import "./style.css";

import logo from "./../../images/ss.jpg";
import qrCodeImg from "./../../images/qr_code.jpg";

import { API_URL } from "./../../global";
import { event } from "jquery";
// import { stat } from "original-fs";

const axios = require("axios");


const options = [
    { value: 'beverages', label: 'Beverages' },
    { value: 'snacks', label: 'Snacks' },
    { value: 'grocery', label: 'Grocery' },
    { value: 'bakery', label: 'Bakery' },

];



export default class BillManager extends Component {
    constructor(props) {
        super();

        this.state = {
            loadingCharges: 0,
            loadingChargesCheck: false,
            vehicleCharges: 0,
            vehicleChargesCheck: false,
            billId: null,
            partyId: 0,
            partyName: null,
            newPartyName: null,
            address: null,
            partyMobile: null,
            gst: "",
            billType: 2,
            productName: null,
            productId: 0,
            routeName: "",
            date: moment(new Date()).format("YYYY-MM-DD"),
            particularValue: null,
            particular: null,
            id: null,
            quantity: 0,
            rate: 0,
            amount: 0,
            itemList: [],
            addedItems: [],
            total: 0,
            balance: 0,
            sgst: 0,
            cgst: 0,
            igst: 0,
            advance: 0,
            nextServiceKm: null,
            dueDate: moment(new Date()).format("YYYY-MM-DD"),
            grandTotal: 0,
            printComponentRef: null,
            partyList: null,
            latestInsertId: 0,
            productList: [],
            selectedCompany: '',
            allProductCompany: [],
            filteredCompany: [],
      
        };
    }

    getIdPartyList() {
        let url = API_URL;
        // const query = `SELECT CONCAT(id, ', ', name) AS name, address FROM party;`;
        const query = `SELECT id, name, mobile, address FROM party;`;
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                this.setState({ partyList: res.data });
            })
            .catch((err) => {
                console.log("id + name fetch error: ", err);
            });
    }

    getLatestId = (type) => {
        let url = API_URL;
        let query = `SELECT id FROM gstbill ORDER BY id DESC LIMIT 1;`;
        if (type === 2) {
            query = `SELECT id FROM nongstbill ORDER BY id DESC LIMIT 1;`
        }
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                this.setState({
                    billId: (res.data[0] != null ? res.data[0]["id"] : 0) + 1,
                });
            })
            .catch((err) => {
                console.log("latest id data fetch error: ", err);
            });
    };

    fetchProducts = () => {
        const query = `SELECT * from products WHERE company = '${this.state.selectedCompany}';`;
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(API_URL, data)
            .then((res) => {
                let _res = res.data.map((item) => {
                    return item.id + "," + item.name + "," + item.remaining_qty + `(${item.remaining_boxes})`;
                });
                this.setState({ productList: _res });
                console.log(res.data)
            })
            .catch((err) => {
                console.log("productlist data fetch error: ", err);
            });
    };
    fetchAllProducts = () => {
        const query = "SELECT company from products";
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(API_URL, data)
            .then((res) => {
                let _res = res.data;
                const company = _res
                    .filter((item) => item.company !== null)
                    .map((item) => item.company)
                    .filter((company, index, self) => self.indexOf(company) === index);
                this.setState({ allProductCompany: company })
      
            })
            .catch((err) => {
                console.log("company data fetch error: ", err);
            });

    };

    caluclateWeight = (field, value) => {
        if (field === "totalBoxes") {
            let weight = value * this.state.weightPerBox;
            this.setState({ totalBoxes: value });
            this.setState({ weight: weight });
        } else if (field === "weightPerBox") {
            let weight = this.state.totalBoxes * value;
            this.setState({ weightPerBox: value });
            this.setState({ weight: weight });
        }
    };

    calculateAmount = (field, value) => {
        if (field === "weight") {
            let amount = value * this.state.rate;
            this.setState({ weight: value });
            this.setState({ amount: amount });
        } else if (field === "rate") {
            let amount = this.state.weight * value;
            this.setState({ rate: value });
            this.setState({ amount: amount });
        }
    };

    calculateTaxes = () => {
        const total = this.state.total;
        this.setState(
            {
                sgst: Number((total / 100) * 9).toFixed(2),
                cgst: Number((total / 100) * 9).toFixed(2),
                igst: Number((total / 100) * 18).toFixed(2),
            },
            this.calculateGrandTotal
        );
    };

    calculateGrandTotal = () => {
        let grandTotal;
        if (this.state.billType === 1) {
            grandTotal = Number(this.state.total) + Number(this.state.igst)
        } else {
            grandTotal = Number(this.state.total)
        }

        if (this.state.loadingChargesCheck)
            grandTotal += Number(this.state.loadingCharges)
        if (this.state.vehicleChargesCheck)
            grandTotal += Number(this.state.vehicleCharges);
        this.setState({ grandTotal: grandTotal.toFixed(2) });
    };

    addItems = () => {
        if (!this.state.productId || !this.state.rate) return;
        // let items = this.state.itemList;
        let items = this.state.addedItems;
        const ifExists = items.find(
            (item) => item.productId === this.state.productId
        );
        if (ifExists) {
            items = items.map((item) => {
                if (item.productId === this.state.productId) {
                    return {
                        productId: this.state.productId,
                        productName: this.state.productName,
                        quantity: item.quantity + this.state.quantity,
                        amount: this.state.rate * (item.quantity + this.state.quantity),
                    };
                } else {
                    return item;
                }
            });
        } else {
            items.push({
                productId: this.state.productId,
                productName: this.state.productName,
                particular: this.state.particular,
                quantity: this.state.quantity,
                rate: this.state.rate,
                amount: this.state.rate * this.state.quantity,
            });
        }
        // items.push({
        //     particular: this.state.particular,
        //     mark: this.state.mark,
        //     totalBoxes: this.state.totalBoxes,
        //     weightPerBox: this.state.weightPerBox,
        //     weight: this.state.weight,
        //     rate: this.state.rate,
        //     amount: this.state.amount,
        // });

        this.setState({ addedItems: items });

        // update total & balance
        // let total = Number(this.state.total) + Number(this.state.amount);
        let total =
            Number(this.state.total) +
            Number(this.state.rate * this.state.quantity);
        this.setState({ total: total }, this.calculateTaxes);
        let balance = total + Number(this.state.advance);
        this.setState({ balance: balance });
        // this.calculateTaxes();
    };

    deleteItem = (index) => {
        // let itemList = this.state.itemList;
        let itemList = this.state.addedItems;

        // update total & balance
        let total = this.state.total - itemList[index]["amount"];
        let balance = total + Number(this.state.advance);
        this.setState({ total: total }, this.calculateTaxes);
        this.setState({ balance: balance });

        // remove element
        // let updatedList = itemList.filter((item, _index) => {
        //     if (index !== _index) return item;
        // });
        // this.setState({ itemList: updatedList });
        let updatedList = itemList.filter((item, _index) => {
            if (index !== _index) return item;
        });
        this.setState({ addedItems: updatedList });
    };

    handleClear = () => {
        window.location.reload(false);
    };

    updateQuantity = (quantity, productId) => {
        let query;

        quantity = Math.ceil(quantity);
        query = `update products set distributed_qty = distributed_qty + ${this.state.quantity} where id = ${this.state.productId}`;

        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(API_URL, data)
            .then((res) => {
                console.log("quantity updated successfully");
                // setBillId(res.data.insertId);
                // insertBillList(res.data.insertId);
            })
            .catch((err) => {
                toast.error("Failed to Load Quantity ");
            });
    };

    insertBillList = () => {
        let url = API_URL;

        // 1.  insert into deliveryMemoList
        const query = `INSERT INTO billlist(billType, billId, partyId, particular,quantity, rate, amount, status) VALUES
        ${this.state.addedItems.map((item, index) => {
            return `(
                ${this.state.billType},
                ${this.state.billId},
                ${this.state.partyId},
                '${item.productName}',
                ${item.quantity}, 
                ${item.rate}, 
                ${item.amount},
                1
           )`
        })}`;
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                this.updateQuantity();
                console.log("insert billlist successfull!");
            })
            .catch((err) => {
                console.log("failed to insert billlist, error: ", err);
            });
    };

    insertLedgerRecord = () => {
        // 1.  insert into ledger
        const query = `INSERT INTO ledger(party_id, particular, total, memo_id) VALUES(${this.state.partyId}, 'reference bill id: ${this.state.latestInsertId}', ${this.state.total}, ${this.state.latestInsertId})`;

        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(API_URL, data)
            .then((res) => {
                console.log("insert ledger successful");
            })
            .catch((err) => {
                console.log("failed to insert ledger, error: ", err);
            });
    };

    insertNewPartyAndSave = () => {
        const query = `INSERT INTO party (name, address, mobile) values("${this.state.newPartyName}", "${this.state.address}", "${this.state.partyMobile}")`;
        const data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(API_URL, data)
            .then((res) => {
                console.log("insert new party successful");
                this.setState({ partyId: res.data.insertId }, this.saveBill);
            })
            .catch((err) => {
                console.log("failed to insert new party, error: ", err);
            });

    };

    saveBill = () => {
        const newDate = moment(new Date()).format("YYYY-MM-DD");
        let query;
        if (this.state.billType === 1) {
            query = `INSERT INTO gstbill (partyId, total, gstin, paid, balance, date, status, vehicle_charges, loading_charges) values(
            ${this.state.partyId}, 
            ${this.state.grandTotal},
            '${this.state.gst}', 
            ${this.state.advance},
            ${this.state.grandTotal - this.state.advance}, 
            '${newDate}', 
            1,
            ${this.state.vehicleCharges},
            ${this.state.loadingCharges})`;

            let data = { crossDomain: true, crossOrigin: true, query: query };
            axios
                .post(API_URL, data)
                .then((res) => {
                    toast.success("Generated Bill successfully");
                    this.setState(
                        { billId: res.data.insertId },
                        this.insertBillList
                    );
                })
                .catch((err) => {
                    toast.error("Failed to Generate Bill ");
                });
        } else {
            query = `INSERT INTO nongstbill (partyId, total, paid, balance, date, status, vehicle_charges, loading_charges) values(
                ${this.state.partyId}, 
                ${this.state.grandTotal},
                ${this.state.advance},
                ${this.state.grandTotal - this.state.advance}, 
                '${newDate}', 
                1,
                ${this.state.vehicleCharges},
                ${this.state.loadingCharges})`;

            let data = { crossDomain: true, crossOrigin: true, query: query };
            axios
                .post(API_URL, data)
                .then((res) => {
                    toast.success("Generated Bill successfully");
                    this.setState(
                        { billId: res.data.insertId },
                        this.insertBillList
                    );
                })
                .catch((err) => {
                    toast.error("Failed to Generate Bill ");
                });
        }
    };
    

    handleSave = async (e) => {
        e.preventDefault();

        // check party already exists
        let partyId = this.state.partyId;
        if (partyId === null) {
            this.insertNewPartyAndSave();
        } else {
            this.saveBill();
        }
    };

    handleSavePrint = (e) => {
        // 1. handle save
        this.handleSave();
    };
    handleCat = (event) => {
        this.setState({ selectedCompany: event.target.value });
    }

    componentDidMount() {
        this.getLatestId();
        this.getIdPartyList();
        this.fetchProducts();
        this.fetchAllProducts();


    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedCompany !== this.state.selectedCompany) {
            this.fetchProducts();
        }
    }




    render() {
        return (
            <form className="mb-5" onSubmit={(e) => e.preventDefault()}>
                {/* Input Party Details */}

                <FormControl
                    style={{ minWidth: "250px" }}
                    className="mr-2 mb-2 smt-0"
                >
                    <Autocomplete
                        id="free-solo-demo"
                        freeSolo
                        options={
                            this.state.partyList != null
                                ? this.state.partyList.map(
                                    (item) => item.id + ", " + item.name
                                )
                                : []
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                // label="party name"
                                label="Party name"
                                variant="outlined"
                                size="small"
                                value={this.state.newPartyName}
                                onChange={(event) =>
                                    this.setState({
                                        newPartyName: event.target.value,
                                    })
                                }
                            />
                        )}
                        onChange={(event, value) => {
                            if (value != null && value.length > 2) {
                                this.setState({
                                    partyId: value.split(", ")[0],
                                    partyName: value.split(", ")[1],
                                    address: this.state.partyList.find(
                                        (party) =>
                                            party.id == value.split(", ")[0]
                                    )?.address,
                                    partyMobile: this.state.partyList.find(
                                        (party) =>
                                            party.id == value.split(", ")[0]
                                    )?.mobile,
                                });
                            } else {
                                this.setState({
                                    partyId: null,
                                    partyName: "",
                                });
                            }
                        }}
                    />
                </FormControl>

                <TextField
                    id="custAddress"
                    label="Address"
                    variant="outlined"
                    className="mr-2"
                    value={this.state.address || ""}
                    onChange={(e) => this.setState({ address: e.target.value })}
                    // required="true"
                    size="small"
                />

                <TextField
                    id="partyMobile"
                    label="Party Mobile"
                    variant="outlined"
                    className="mr-2"
                    value={this.state.partyMobile || ""}
                    onChange={(e) =>
                        this.setState({ partyMobile: e.target.value })
                    }
                    // required="true"
                    size="small"
                />

                <FormControl
                    variant="filled"
                    className="mr-2 mb-2"
                    style={{ minWidth: "180px" }}
                    size="small"
                >
                    <InputLabel id="demo-simple-select-outlined-label">
                        Bill Type
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        onChange={(e) =>
                            this.setState({ billType: e.target.value }, () => this.getLatestId(e.target.value))
                        }
                        name="billType"
                        value={this.state.billType}
                        size="small"
                    >
                        <MenuItem value={2}>Non GST</MenuItem>
                        <MenuItem value={1}>GST</MenuItem>

                    </Select>
                </FormControl>

                <TextField
                    id="gstin"
                    label="GSTIN"
                    variant="outlined"
                    className={"mr-2  " + (this.state.billType === 2 ? 'd-none' : '')}
                    value={this.state.gstin}
                    onChange={(e) => this.setState({ gst: e.target.value })}

                    size="small"
                />

                <TextField
                    id="advance"
                    label="Advance"
                    variant="outlined"
                    className="mr-2"
                    value={this.state.advance}
                    onChange={(e) => this.setState({ advance: e.target.value })}
                    // required="true"
                    size="small"
                    type="number"
                    style={{ width: "150px" }}
                />


                {/* End of Input Party Details */}

                <hr />

                <Row>
                    <Col>


                        <Box
                            display={"inline-block"}
                            px={1}
                            pb={1}
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '25ch' },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <div>
                          
                                <TextField
                                    id="outlined-select-currency"
                                    select
                                    label="Select Company"
                                    variant="filled"
                                    size="small"
                                    value={this.state.selectedCompany}
                                    onChange={this.handleCat}
                                >
                                    {this.state.allProductCompany?.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </TextField></div></Box>

                        <FormControl
                            style={{ minWidth: "250px" }}
                            className="mr-2 mb-2 mt-1 smt-0"
                        >
                            <Autocomplete
                                id="free-solo-demo"
                                freeSolo
                                options={
                                    this.state.productList != null
                                        ? this.state.productList.map(
                                            (item) => item
                                        )
                                        : []
                                }
                                renderOption={(props, option) => {
                                    console.log("renderOption : ", option, props)
                                    let val = props
                                    if (val) {
                                        val = val.split(",")
                                        val = `${val[1]}:${val[2]}`
                                    }
                                    return (
                                        <Box component="li" {...props}>
                                            {val}
                                        </Box>
                                    )
                                }}
                                renderInput={(params) => {
                                    let val = params.inputProps.value
                                    if (val) {
                                        val = val.split(",")
                                        val = `${val[1]}:${val[2]}`
                                        params.inputProps.value = val
                                    }
                                    return (
                                        <TextField
                                            {...params}
                                            // label="party name"
                                            label="product"
                                            variant="outlined"
                                            size="small"
                                        />
                                    )
                                }}
                                onChange={(event, value) => {
                                    if (value != null && value.length > 2)
                                        this.setState({
                                            productId: value.split(",")[0],
                                        });
                                    this.setState({
                                        productName: value.split(",")[1],
                                    });
                                    // this.setState({ particular: value});
                                }}
                            />
                        </FormControl>

                        <TextField
                            id="rate"
                            label="Rate"
                            variant="outlined"
                            className="mr-2 mt-1"
                            value={this.state.rate}
                            onChange={(e) =>
                                this.setState({ rate: e.target.value })
                            }
                            // required="true"
                            size="small"
                            type="number"
                        />

                        <TextField
                            id="quantity"
                            label="Quantity"
                            variant="outlined"
                            className="mr-2 mt-1"
                            value={this.state.quantity}
                            onChange={(e) =>
                                this.setState({ quantity: e.target.value })
                            }
                            // required="true"
                            size="small"
                            type="number"
                        />

                        <Button
                            color="primary"
                            variant="contained"
                            className="mt-1"
                            onClick={this.addItems}
                        // disabled={
                        //     !this.state.productName ||
                        //     !this.state.rate ||
                        //     !this.state.quantity
                        // }
                        >
                            Add
                        </Button> <br />
                        {/* <Checkbox checked={this.state.loadingChargesCheck} onChange={(e) => {
                            this.setState({
                                loadingChargesCheck: !this.state.loadingChargesCheck
                            })
                            this.calculateTaxes()
                        }} /> */}
                        {/* <TextField
                            id="Loading Charges"
                            label="Loading Charges"
                            variant="outlined"
                            className="mr-2 mt-1"
                            value={this.state.loadingCharges}
                            onChange={(e) =>
                                this.setState({ loadingCharges: e.target.value }, this.calculateTaxes)
                            }
                            // required="true"
                            size="small"
                            type="number"
                            disabled={!this.state.loadingChargesCheck}
                        />
                        <Checkbox checked={this.state.vehicleChargesCheck} onChange={(e) => {
                            this.setState({
                                vehicleChargesCheck: !this.state.vehicleChargesCheck
                            })
                            this.calculateTaxes()
                        }} />
                        <TextField
                            id="Vehicle Charges"
                            label="Vehicle Charges"
                            variant="outlined"
                            className="mr-2 mt-1"
                            value={this.state.vehicleCharges}
                            onChange={(e) =>
                                this.setState({ vehicleCharges: e.target.value }, this.calculateTaxes)
                            }
                            // required="true"
                            size="small"
                            type="number"
                            disabled={!this.state.vehicleChargesCheck}
                        /> */}
                    </Col>
                </Row>

                <div
                    className="mt-1 p-2 measure   "
                    ref={(el) => (this.printComponentRef = el)}
                >
                    <Row>
                        <Col md={8} className="mx-auto  ">
                            <Card className="mt-2 p-0">
                                <h6 className="text-center bg-info py-1">
                                    TAX INVOICE
                                </h6>

                                <Card.Header>
                                    <Row>
                                        <div className="col-3">
                                            <img
                                                src={logo}
                                                width="150"
                                                height="100"
                                                alt="logo"
                                            />
                                        </div>
                                        <div className="col-9 pb-2 mx-0">
                                            <div className="text-left pb-0 mb-0">
                                                <b className="h3">
                                                    ओम गगनगिरी डिस्ट्रीब्युटर्स
                                                </b>
                                                <p style={{ fontSize: "11px", marginTop: "12px", }}>जीरा सोडा, कोल्ड्रिंक्स, ज्यूस, बिस्कीट, बेकरी उत्पादने,पिण्याचे पाणी, डिटर्जेंट पावडर व साबण व इतर सर्व वस्तूंचे होलसेल व्यापारी</p>
                                                <hr style={{ width: '100%' }} />
                                                <p
                                                    className="text-start pb-0 mb-0"
                                                    style={{ fontSize: "14px" }}
                                                >
                                                    सिद्धिविनायक कॉलनी, पाटबंधारे विभागाच्या पाठीमागे, कोकरूड रोड, ३२ शिराळा, सांगली - 415408
                                                </p>
                                            </div>
                                        </div>
                                    </Row>
                                    <hr />
                                    <div className="text-center">

                                        <p >
                                            Phone No.: राहुल आनंदा वरेकर - 7399119111
                                        </p>

                                    </div>

                                    <hr />
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <p>
                                            Invoice No.{" "}
                                            <b>{this.state.billId}</b>
                                        </p>
                                        <p>
                                            Date{" "}
                                            <b>
                                                {moment(new Date()).format(
                                                    "D/M/YYYY"
                                                )}
                                            </b>
                                        </p>
                                    </span>
                                </Card.Header>
                                <Card.Body className="pb-3 mb-0">
                                    <Row>
                                        <div className="col-6 col-md-6">
                                            <h6
                                                style={{
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                Party name:{" "}
                                                <b>
                                                    {this.state.partyName ||
                                                        this.state.newPartyName}
                                                </b>
                                            </h6>
                                        </div>
                                        <div className="col-6 col-md-6">
                                            <h6
                                                style={{
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                Address:{" "}
                                                <b>{this.state.address}</b>
                                            </h6>
                                        </div>
                                        <div className="col-6 col-md-6">
                                            <h6
                                                style={{
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                GSTIN: <b>{this.state.gst}</b>
                                            </h6>
                                        </div>
                                        <div className="col-6 col-md-6">
                                            <h6
                                                style={{
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                Mobile No.:{" "}
                                                <b>{this.state.partyMobile}</b>
                                            </h6>
                                        </div>

                                    </Row>
                                </Card.Body>
                                <Card.Body className="m-0 pt-0">
                                    {/* Order overview */}
                                    <Tbl striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>Particular</th>
                                                <th>Quantity</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                                {/* <th>Action</th> */}
                                            </tr>
                                        </thead>
                                        {this.state.addedItems.length > 0 ? (
                                            <tbody>
                                                {this.state.addedItems.map(
                                                    (item, index) => {
                                                        return (
                                                            <tr
                                                                key={item.productId}
                                                            >
                                                                <td>
                                                                    {
                                                                        item.productName
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        item.quantity
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {item.rate}
                                                                </td>
                                                                <td>
                                                                    {
                                                                        item.amount
                                                                    }
                                                                </td>
                                                                <td
                                                                    className="d-print-none"
                                                                    align="center"
                                                                >
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        onClick={() =>
                                                                            this.deleteItem(
                                                                                index
                                                                            )
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faTrash
                                                                            }
                                                                        />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }
                                                )}
                                                <br></br>
                                                {this.state.billType === 1 ? (
                                                    <>
                                                        <tr>
                                                            <td colSpan="3">
                                                                Total amount
                                                                before tax
                                                            </td>
                                                            <td colSpan="2">
                                                                {
                                                                    this.state
                                                                        .total
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="3">
                                                                SGST 9%
                                                            </td>
                                                            <td colSpan="2">
                                                                {
                                                                    this.state
                                                                        .sgst
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="3">
                                                                CGST 9%
                                                            </td>
                                                            <td colSpan="2">
                                                                {
                                                                    this.state
                                                                        .cgst
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="3">
                                                                IGST 18%
                                                            </td>
                                                            <td colSpan="2">
                                                                {
                                                                    this.state
                                                                        .igst
                                                                }
                                                            </td>
                                                        </tr>
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3">
                                                            Total amount
                                                        </td>
                                                        <td colSpan="2">
                                                            {this.state.total}
                                                        </td>
                                                    </tr>
                                                )}
                                                {
                                                    this.state.loadingChargesCheck ?
                                                        <tr>
                                                            <td colSpan="3">
                                                                Loading Charges
                                                            </td>
                                                            <td colSpan="2">
                                                                {
                                                                    this.state
                                                                        .loadingCharges
                                                                }
                                                            </td>
                                                        </tr>
                                                        :
                                                        ""
                                                }
                                                {
                                                    this.state.vehicleChargesCheck ?
                                                        <tr>
                                                            <td colSpan="3">
                                                                Vehicle Charges
                                                            </td>
                                                            <td colSpan="2">
                                                                {
                                                                    this.state
                                                                        .vehicleCharges
                                                                }
                                                            </td>
                                                        </tr>
                                                        :
                                                        ""
                                                }
                                                <tr>
                                                    <td colSpan="3">
                                                        <b>Grand Total</b>
                                                    </td>
                                                    <td colSpan="2">
                                                        <b>
                                                            {
                                                                this.state
                                                                    .grandTotal
                                                            }
                                                        </b>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ) : (
                                            <tbody>
                                                <tr>
                                                    <td colSpan="6">
                                                        No items added
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )}
                                    </Tbl>
                                </Card.Body>
                                <Card.Footer className="pb-3 mb-0">
                                    <Row>
                                        <Col>
                                            {/* <h6
                                                style={{
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                GSTIN No.: <b>27AOLPK5202K1ZU</b>
                                            </h6> */}
                                            <h6
                                                style={{
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                {/* Date: 28/06/2017 */}
                                            </h6>
                                            <h6
                                                style={{
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                State : Maharashtra
                                            </h6>
                                            <h6
                                                style={{
                                                    textTransform: "capitalize",
                                                }}
                                            >
                                                Code: 27
                                            </h6>
                                        </Col>
                                        <Col style={{ textAlign: "center" }}>
                                            <img src={qrCodeImg} height="85%" width="75%" alt="qr code" />
                                        </Col>
                                        <Col>
                                            <table style={{ borderCollapse: "collapse" }}>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px", }}>Account Holder</td>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px", fontWeight: "bold" }}>OM GAGANGIRI DISTRIBUTORS</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px" }}>Account Number</td>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", padding: "3px", fontSize: "10px", fontWeight: "bold" }}>50200073571261</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px" }}>IFSC</td>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px", fontWeight: "bold" }}>HDFC0002455</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px" }}>Branch</td>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px", fontWeight: "bold" }}>ISLAMPUR URAN</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px" }}>Account Type</td>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px" }}>CURRENT</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px" }}>Virtual Payment Address</td>
                                                        <td style={{ textTransform: "capitalize", padding: "3px", fontSize: "10px" }}>8329738137@hdfcbank</td>
                                                    </tr>
                                                </tbody>
                                            </table>



                                        </Col>
                                    </Row>
                                    <Row className="mt-1">
                                        <div className="col-12" style={{ textAlign: "center", color: "grey" }}>developed by 5TechG Lab | M:7028828831</div>
                                    </Row>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <div className="row">
                    <div className="col-10">
                        <ReactToPrint content={() => this.printComponentRef}>
                            <PrintContextConsumer>
                                {({ handlePrint }) => (
                                    <Button
                                        onClick={handlePrint}
                                        className="mt-2 mr-1"
                                        color="primary"
                                        variant="contained"
                                        style={{ float: "right" }}
                                        disabled={
                                            (this.state.partyName ||
                                                this.state.newPartyName) &&
                                                this.state.address
                                                ? false
                                                : true
                                        }
                                    >
                                        Print
                                    </Button>
                                )}
                            </PrintContextConsumer>
                        </ReactToPrint>

                        <Button
                            className="mt-2 mr-1"
                            color="primary"
                            variant="contained"
                            style={{ float: "right" }}
                            // type="submit"
                            onClick={this.handleSave}
                            disabled={
                                (this.state.partyName ||
                                    this.state.newPartyName) &&
                                    this.state.address
                                    ? false
                                    : true
                            }
                        >
                            Save bill
                        </Button>
                        <Button
                            className="mt-2 mr-1"
                            color="primary"
                            variant="contained"
                            style={{ float: "right" }}
                            onClick={this.handleClear}
                        >
                            clear
                        </Button>
                    </div>
                </div>
            </form>
        );
    }
}
